@for (item of menu(); track $index) {
  <button
    class="group flex place-items-center gap-2 rounded-full px-3 hover:bg-[#002024]/10 dark:hover:bg-white/10 [&.open]:bg-[#F3F0F4] dark:[&.open]:text-[#1E1E1E]"
    type="button"
    aria-haspopup="dialog"
    [attr.aria-expanded]="isOpen() ? 'true' : 'false'"
    [attr.aria-controls]="isOpen() ? 'headernav-panel' : null"
    [attr.aria-selected]="isOpen() ? 'true' : 'false'"
    [attr.aria-label]="item.text"
    [ngClass]="{ open: isOpen() && activeMenuIndex() === $index }"
    [shebaGtmClick]="{ user_action: 'user_clicks_top_menu', click_level_1: item.text }"
    (click)="onMenuButtonClick($index)"
    matRipple
  >
    {{ item.text }}
    <span class="flex h-6 w-6 place-content-center place-items-center transition-transform group-[.open]:rotate-180">
      <sheba-arrow-down-icon />
    </span>
  </button>
}

<ng-template
  #overlay="cdkConnectedOverlay"
  [cdkConnectedOverlayOrigin]="overlayOrigin()"
  [cdkConnectedOverlayPositions]="[{ originX: 'center', originY: 'bottom', overlayX: 'center', overlayY: 'top' }]"
  [cdkConnectedOverlayScrollStrategy]="blockScrollStrategy"
  [cdkConnectedOverlayOpen]="isOpen()"
  [cdkConnectedOverlayHasBackdrop]="true"
  [cdkConnectedOverlayBackdropClass]="['opacity-1']"
  [cdkConnectedOverlayDisableClose]="false"
  (detach)="isOpen.set(false)"
  (overlayOutsideClick)="isOpen.set(false)"
  cdkConnectedOverlay
>
  <div
    class="m-4 hidden h-[432px] w-[1024px] overflow-hidden rounded-3xl bg-white shadow-xl md:flex"
    id="search-panel"
    role="dialog"
    @openClose
    [cdkTrapFocusAutoCapture]="true"
    (backdropClick)="isOpen.set(false)"
    cdkTrapFocus
  >
    <div class="relative flex h-full w-1/4 flex-col bg-[#EAF2FA]" role="tablist">
      @for (item of menu()?.[activeMenuIndex()]?.children; track $index) {
        <button
          class="z-10 flex h-1/6 place-items-center px-8 text-start text-lg leading-6 hover:bg-[#002024]/10 dark:hover:bg-white/10"
          role="tab"
          [id]="'tab-' + $index"
          [ngClass]="[activeIndex() === $index ? 'font-bold text-[#010965]' : 'font-normal text-[#46464F]']"
          [attr.aria-selected]="activeIndex() === $index ? 'true' : 'false'"
          [attr.aria-controls]="'headernav-panel-' + $index"
          [shebaGtmClick]="{
            user_action: 'user_clicks_top_menu',
            click_level_1: menu()?.[activeMenuIndex()]?.text,
            click_level_2: item.text
          }"
          (click)="activeIndex.set($index)"
          matRipple
          matRippleColor="#white"
        >
          {{ item.text }}
        </button>
      }
      <div
        class="absolute top-0 z-[1] flex h-1/6 w-full translate-y-0 bg-white transition-transform"
        [style.--tw-translate-y.%]="activeIndex() * 100"
        [style.height]="itemsCount > 6 ? 432 / itemsCount + 'px' : '16.6667%'"
      >
        <div class="absolute inset-y-0 end-0 flex place-content-center place-items-center pe-4">
          <sheba-arrow-stick-small-icon class="text-[#EA3D85]" />
        </div>
      </div>
    </div>
    <div class="flex w-3/4">
      <div
        class="flex w-1/3 flex-col flex-wrap"
        role="tabpanel"
        [id]="'headernav-panel-' + activeIndex()"
        [attr.aria-labelledby]="'tab-' + activeIndex()"
      >
        @for (item of menu()?.[activeMenuIndex()]?.children?.[activeIndex()]?.children; track $index) {
          <a
            class="flex h-1/6 place-content-start place-items-center px-8 text-start text-lg leading-6 text-[#010965] hover:bg-[#002024]/10 dark:hover:bg-white/10"
            [href]="item.link?.url ?? item.link?.route?.path | sanitizeUrl"
            [attr.target]="item.link?.target"
            [shebaGtmClick]="{
              user_action: 'user_clicks_top_menu',
              click_level_1: menu()?.[activeMenuIndex()]?.text,
              click_level_2: menu()?.[activeMenuIndex()]?.children?.[activeIndex()]?.text,
              click_level_3: item.text
            }"
            (click)="isOpen.set(false)"
            routerLinkDetector
          >
            {{ item.text }}
          </a>
        }
      </div>
    </div>
  </div>
</ng-template>
